import { Component, OnInit, ViewChild } from '@angular/core'
import { Router } from '@angular/router'
import { NgForm } from '@angular/forms'
import { MatDialog, MatDialogConfig } from '@angular/material/dialog'
import { UntypedFormBuilder, FormControl, FormGroup } from '@angular/forms'

import { SiteService } from '../../../../services/site.service'
import { MessageService } from '../../../../services/message.service'
import { TranslateService } from '@ngx-translate/core'
import { CustomerRequestsService } from '../../../../services/customer-requests.service'

import { CustomerAccountTypes } from '../../../../enumeration'
import { NameChangeViewModel } from '../../../../models/nameChangeViewModel'
import { ErrorMessageModalComponent } from '../../../modals/error-message-modal/error-message-modal.component'

@Component({
    selector: 'app-request-name-change-detail',
    templateUrl: './request-name-change-detail.component.html',
    styleUrls: ['./request-name-change-detail.component.scss'],
    standalone: false
})
export class RequestNameChangeDetailComponent implements OnInit 
{
  @ViewChild('customForm') public customForm!: NgForm
  formSubmitted: boolean = false
  invalidGovernmentIdFile: boolean = false
  invalidVehicleRegistrationFile: boolean = false
  invalidInsurancePolicyFile: boolean = false
  invalidArticlesOfIncorporationFile: boolean = false
  isActiveLease: boolean = true
  governmentIdIsRequired: boolean = true
  articlesOfIncorporationIsRequired: boolean = true

  request =
  {
    lastName: '',
    firstName: ''
  }
  governmentIdFile: any = undefined
  vehicleRegistrationFile: any = undefined
  insurancePolicyFile: any = undefined
  articlesOfIncorporationFile: any = undefined
  referenceNumber: string = ''
  nameChangeViewModel = new NameChangeViewModel()

  constructor(
    private router: Router,
    public dialog: MatDialog,
    private siteService: SiteService,
    private messageService: MessageService,
    private translateService: TranslateService,
    private formBuilder: UntypedFormBuilder,
    private customerRequestsService: CustomerRequestsService
  ) 
  { 
  }

  ngOnInit() 
  {
    this.retrieveNameChangeViewModel()
  }

  retrieveNameChangeViewModel()
	{
		this.messageService.startedHttpRequest('retrieveNameChangeViewModel')
		this.customerRequestsService
			.getNameChangeViewModel()
			.subscribe({
				next: (apiResponse) =>
        {
          this.nameChangeViewModel = apiResponse

          if(this.nameChangeViewModel && this.nameChangeViewModel.isActiveLease)
          {
              this.articlesOfIncorporationIsRequired = 
                this.nameChangeViewModel.customerAccountType == CustomerAccountTypes.SoleProprietorship ||
                this.nameChangeViewModel.customerAccountType == CustomerAccountTypes.Partnership ||
                this.nameChangeViewModel.customerAccountType == CustomerAccountTypes.Corporation ||
                this.nameChangeViewModel.customerAccountType == CustomerAccountTypes.Municipality ||
                this.nameChangeViewModel.customerAccountType == CustomerAccountTypes.NonProfitOrganization

              this.governmentIdIsRequired = !this.articlesOfIncorporationIsRequired
          
              if(this.governmentIdIsRequired)
              {
                const governmentIdFileuploadBtn = document.getElementById('governmentIdFileBtn');
                const governmentIdFileInput = document.getElementById('governmentIdFileInput');

                if (governmentIdFileuploadBtn && governmentIdFileInput) {
                  governmentIdFileuploadBtn.addEventListener('click', () => {
                    governmentIdFileInput.click()
                  })
                }
              }	

              if(this.articlesOfIncorporationIsRequired)
              {
                const articlesOfIncorporationFileuploadBtn = document.getElementById('articlesOfIncorporationFileBtn');
                const articlesOfIncorporationFileInput = document.getElementById('articlesOfIncorporationFileInput');

                if (articlesOfIncorporationFileuploadBtn && articlesOfIncorporationFileInput) {                
                  articlesOfIncorporationFileuploadBtn.addEventListener('click', () => {
                    articlesOfIncorporationFileInput.click()
                  })
                }
              }	

              const vehicleRegistrationFileBtn = document.getElementById('vehicleRegistrationFileBtn')
              const vehicleRegistrationFileInput = document.getElementById('vehicleRegistrationFileInput')

              if (vehicleRegistrationFileBtn && vehicleRegistrationFileInput) {  
                vehicleRegistrationFileBtn.addEventListener('click', () => {
                  vehicleRegistrationFileInput.click()
                })
              }
          
              const insurancePolicyFileBtn = document.getElementById('insurancePolicyFileBtn')
              const insurancePolicyFileInput = document.getElementById('insurancePolicyFileInput')

              if (insurancePolicyFileBtn && insurancePolicyFileInput) {  
                insurancePolicyFileBtn.addEventListener('click', () => {
                  insurancePolicyFileInput.click()
              })		
            }
          }
          else
          {
            this.isActiveLease = false
          }
        },
				error: (error) =>
				{
          this.isActiveLease = false
          this.messageService.completedHttpRequest('retrieveNameChangeViewModel')
      
          const dialogConfig = new MatDialogConfig()
          dialogConfig.width = '500px',
          dialogConfig.data = {
            title: this.translateService.instant('COMMON_LBL_ERROR'),
            message: this.translateService.instant('COMMON_LBL_ERROR_MSG')
          }		
          this.dialog.open(ErrorMessageModalComponent, dialogConfig)
				},
				complete: () =>
				{
					this.messageService.completedHttpRequest('retrieveNameChangeViewModel')
				}
			})
	}

  handleGovernmentIdFileInput(files: FileList) 
  {
    this.invalidGovernmentIdFile = false
    this.governmentIdFile = files.item(0);

    if(this.governmentIdFile)
    {
      const allowedExtensions = ['pdf','bmp','jpeg','jpg', 'png', 'gif'];
      const fileExtension = this.governmentIdFile.name.split('.').pop().toLowerCase();
  
      if (!allowedExtensions.includes(fileExtension)) 
      {
        this.invalidGovernmentIdFile = true
      }
    }
  }

  handleVehicleRegistrationFileInput(files: FileList) 
  {
    this.invalidVehicleRegistrationFile = false
    this.vehicleRegistrationFile = files.item(0)

    if(this.vehicleRegistrationFile)
    {
      const allowedExtensions = ['pdf','bmp','jpeg','jpg', 'png', 'gif']
      const fileExtension = this.vehicleRegistrationFile.name.split('.').pop().toLowerCase()
  
      if (!allowedExtensions.includes(fileExtension)) 
      {
        this.invalidVehicleRegistrationFile = true
      }
    }
  }

  handleInsurancePolicyFileInput(files: FileList) 
  {
    this.invalidInsurancePolicyFile = false
    this.insurancePolicyFile = files.item(0)

    if(this.insurancePolicyFile)
    {
      const allowedExtensions = ['pdf','bmp','jpeg','jpg', 'png', 'gif']
      const fileExtension = this.insurancePolicyFile.name.split('.').pop().toLowerCase()
  
      if (!allowedExtensions.includes(fileExtension)) 
      {
        this.invalidInsurancePolicyFile = true
      }
    }
  }

  handleArticlesOfIncorporationFileInput(files: FileList) 
  {
    this.invalidArticlesOfIncorporationFile = false
    this.articlesOfIncorporationFile = files.item(0);

    if(this.articlesOfIncorporationFile)
    {
      const allowedExtensions = ['pdf','bmp','jpeg','jpg', 'png', 'gif'];
      const fileExtension = this.articlesOfIncorporationFile.name.split('.').pop().toLowerCase();
  
      if (!allowedExtensions.includes(fileExtension)) 
      {
        this.invalidArticlesOfIncorporationFile = true
      }
    }
  }

  submitForm(customerForm: NgForm)
  {
    this.formSubmitted = true

    this.validateFiles()

    if(this.governmentIdIsRequired)
		{
			this.validateGovernmentIdFile()
		}

    if(this.articlesOfIncorporationIsRequired)
		{
			this.validateArticlesOfIncorporationFile()
		}

    if (customerForm.invalid || this.invalidGovernmentIdFile || this.invalidVehicleRegistrationFile || this.invalidInsurancePolicyFile || this.invalidArticlesOfIncorporationFile)
    {
      return
    }

    const requestSummaryList: { key: string; value: string }[] = [
      //{ key: this.translateService.instant('REQUEST_NAME_CHANGE_CONFIRM_NAME'), value: this.siteService.customerAccount?.fullName ?? '' },
      { key: this.translateService.instant('REQUEST_NAME_CHANGE_CONFIRM_LEASENUM'), value: this.nameChangeViewModel.leaseNumber },
      { key: this.translateService.instant('REQUEST_NAME_CHANGE_CONFIRM_LASTNAME'), value: this.request.lastName },
      { key: this.translateService.instant('REQUEST_NAME_CHANGE_CONFIRM_FIRSTNAME'), value: this.request.firstName }
    ]

    return this.customerRequestsService.requestConfirmation(this.translateService.instant('REQUEST_NAME_CHANGE_CONFIRM_PRINT_TITLE'), requestSummaryList)
    .then((result) =>
    {
      if(result)
      {
        let formData = new FormData()
        formData.append('lastName', this.request.lastName)
        formData.append('firstName', this.request.firstName)
        formData.append('governmentIdFile', this.governmentIdFile)
        formData.append('vehicleRegistrationFile', this.vehicleRegistrationFile)
        formData.append('insurancePolicyFile', this.insurancePolicyFile)
        formData.append('articlesOfIncorporationFile', this.articlesOfIncorporationFile)

        this.messageService.startedHttpRequest('submitForm')
        this.customerRequestsService
        .addNameChangeRequest(formData)
        .subscribe({
          next: (apiResponse) =>
          {
            this.referenceNumber = apiResponse

            if ((this.referenceNumber != undefined) && (this.referenceNumber != ''))
            {
              this.customerRequestsService.requestSummary(this.referenceNumber, this.translateService.instant('REQUEST_NAME_CHANGE_HEADING'), requestSummaryList)
            
              this.router.navigate(['/request-list'])              
            }	
                          
            this.formSubmitted = false
          },
          error: (error) =>
          {
            this.messageService.completedHttpRequest('submitForm')
      
            const dialogConfig = new MatDialogConfig()
            dialogConfig.width = '500px',
            dialogConfig.data = {
              title: this.translateService.instant('COMMON_LBL_ERROR'),
              message: this.translateService.instant('COMMON_LBL_ERROR_MSG')
            }		
            this.dialog.open(ErrorMessageModalComponent, dialogConfig)
          },
          complete: () =>
          {
            this.messageService.completedHttpRequest('submitForm')
          }
        })
      }
    })	
  }

  validateArticlesOfIncorporationFile()
	{
		this.invalidArticlesOfIncorporationFile = false

		if(this.articlesOfIncorporationFile == undefined)
		{
			this.invalidArticlesOfIncorporationFile = true
		}
		else
		{
			const allowedExtensions = ['pdf','bmp','jpeg','jpg', 'png', 'gif']
			const fileExtension = this.articlesOfIncorporationFile.name.split('.').pop().toLowerCase()

			if (!allowedExtensions.includes(fileExtension)) 
			{
				this.invalidArticlesOfIncorporationFile = true
			}
		}
	}

  validateGovernmentIdFile()
	{
    this.invalidGovernmentIdFile = false
    const allowedExtensions = ['pdf','bmp','jpeg','jpg', 'png', 'gif'];
    let fileExtension = ''

    if(this.governmentIdFile == undefined)
    {
      this.invalidGovernmentIdFile = true
    }
    else
    {
      fileExtension = this.governmentIdFile.name.split('.').pop().toLowerCase();

      if (!allowedExtensions.includes(fileExtension)) 
      {
        this.invalidGovernmentIdFile = true
      }
    }
	}

  validateFiles()
  {
    this.invalidGovernmentIdFile = false
    this.invalidVehicleRegistrationFile = false
    this.invalidInsurancePolicyFile = false
    const allowedExtensions = ['pdf','bmp','jpeg','jpg', 'png', 'gif'];
    let fileExtension = ''

    if(this.vehicleRegistrationFile == undefined)
    {
      this.invalidVehicleRegistrationFile = true
    }
    else
    {
      fileExtension = this.vehicleRegistrationFile.name.split('.').pop().toLowerCase();

      if (!allowedExtensions.includes(fileExtension)) 
      {
        this.invalidVehicleRegistrationFile = true
      }
    }

    if(this.insurancePolicyFile == undefined)
    {
      this.invalidInsurancePolicyFile = true
    }
    else
    {
      fileExtension = this.insurancePolicyFile.name.split('.').pop().toLowerCase();

      if (!allowedExtensions.includes(fileExtension)) 
      {
        this.invalidInsurancePolicyFile = true
      }
    }
  }
}
